<div class="okta-container">
  <div class="row okta-wrapper">
    <div class="okta-form-row">
      <div class="row logo-holder">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 logo-block">
          <img class="app-logo" src="/assets/images/{{websiteName}}/LogoNew.png" alt="" />
        </div>
      </div>
      <div class="row box-container">
        <div class="form-info">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <p class="exp-message welcome-message">Welcome, {{activate.firstname}}!</p>
            <p class="exp-message-sml" *ngIf="isActivateUser()">Let's finish setting up your
              account.</p>
            <p class="exp-message-sml" *ngIf="!isActivateUser()">As a part of enhanced
              security for parmed.com, you are required to set a new password and security question. Please complete
              the
              fields below to continue.</p>
            <form #activateForm="ngForm" novalidate class="form-info account-setup-form" (ngSubmit)="onActivateUserSubmit(activateForm)">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="has-error okta-error" *ngIf="activate.token.expired">
                  <span class="glyphicon glyphicon-exclamation-sign error-exclamation"></span>
                  <p class="show-message">
                    <span title="{{activate.token.message}}">{{activate.token.message}}</span>
                  </p>
                </div>
                <div class="has-error okta-error" *ngIf="activate.errorMessage">
                  <span class="glyphicon glyphicon-exclamation-sign error-exclamation"></span>
                  <p class="show-message">
                    <span title="{{activate.errorMessage}}">{{activate.errorMessage}}</span>
                  </p>
                </div>
                <ul class="form-grid">
                  <li class="activate-control">
                    <mat-form-field>
                      <input id="new-password" matInput name="newpassword" type="password" required #newpassword="ngModel" placeholder="Enter New Password"
                        [(ngModel)]="activate.newPassword" parValidateEqual="confirmPassword" reverse="true" [pattern]="validation.passwordRegex"
                        parAutoFocus>
                      <mat-error *ngIf="newpassword.errors?.required">New password is required.</mat-error>
                    </mat-form-field>
                  </li>
                  <li class="activate-control">
                    <div>
                      <mat-form-field>
                        <input id="confirm-password" matInput name="confirmPassword" type="password" required #confirmPassword="ngModel"
                          placeholder="Confirm New Password" parValidateEqual="newpassword" [(ngModel)]="activate.confirmPassword"
                          [pattern]="validation.passwordRegex">
                        <mat-error *ngIf="confirmPassword.errors?.required">Confirm password is required.</mat-error>
                        <mat-error *ngIf="confirmPassword.errors?.validateEqual">New password and confirm password do
                          not match.</mat-error>
                      </mat-form-field>
                    </div>
                  </li>
                  <li class="password-hint">
                    <p *ngIf="!newpassword.errors?.pattern && !confirmPassword.errors?.pattern">{{messages.passwordHint}}</p>
                    <div *ngIf="newpassword.errors?.pattern || confirmPassword.errors?.pattern" class="has-error okta-error">
                      <span class="glyphicon glyphicon-exclamation-sign error-exclamation"></span>
                      <p class="show-message">
                        <span>{{messages.passwordHint}}</span>
                      </p>
                    </div>
                  </li>
                  <li>
                    <mat-form-field>
                      <mat-select id="question" name="question" [(ngModel)]="activate.question" #question="ngModel" required
                        placeholder="Choose Security Question">
                        <mat-option *ngFor="let question of securityQuestions; let i = index" value="{{question.questionText}}">
                          <span id="question-{{i+1}}"> {{question.questionText}} </span>
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="activateForm.submitted && question.errors?.required">Please select a security
                        question.</mat-error>
                    </mat-form-field>
                  </li>
                  <li class="activate-control">
                    <mat-form-field>
                      <input id="name" matInput name="answer" type="password" required #answer="ngModel" placeholder="Answer"
                        [(ngModel)]="activate.answer" [pattern]="validation.answerRegex" parValidateEqual="confirmAnswer"
                        reverse="true">
                      <mat-error *ngIf="answer.errors?.required">Answer is a required field.</mat-error>
                      <mat-error *ngIf="answer.errors?.pattern">Your answer must have at least
                        {{validation.ansMinLength}} characters.</mat-error>
                    </mat-form-field>
                  </li>
                  <li class="activate-control">
                    <mat-form-field>
                      <input id="confirm-answer" matInput name="confirmAnswer" type="password" required #confirmAnswer="ngModel"
                        placeholder="Confirm Answer" [(ngModel)]="activate.confirmAnswer" [pattern]="validation.answerRegex"
                        parValidateEqual="answer">
                      <mat-error *ngIf="confirmAnswer.errors?.required">Confirm answer is a required field.</mat-error>
                    </mat-form-field>
                  </li>
                  <li class="password-hint">
                    <mat-error *ngIf="confirmAnswer.errors?.pattern">Confirm answer must have at least
                      {{validation.ansMinLength}} characters.</mat-error>
                    <mat-error *ngIf="!answer.errors?.pattern && !confirmAnswer.errors?.pattern && confirmAnswer.errors?.validateEqual">Answer
                      and confirm answer do not match.</mat-error>
                    <p class="answer-hint">{{validation.ansInfoMessage}}</p>
                  </li>
                  <li class="action-button">
                    <button id="submit" type="submit" [disabled]="activateForm.invalid" mat-raised-button color="accent"> {{
                      isActivateUser() ? 'Activate
                      My Account' : 'Continue' }} </button>
                  </li>
                </ul>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>